import { FacebookIcon, InstagramIcon, TikTokIcon, WebsiteIcon, XIcon } from '@/components/profile/SocialIcons'
import { SOCIAL_FIELDS, withHttps, type SocialKey } from '@/lib/socials'

const ICONS: Record<SocialKey, typeof TikTokIcon> = {
  tiktokUrl: TikTokIcon,
  xUrl: XIcon,
  facebookUrl: FacebookIcon,
  instagramUrl: InstagramIcon,
  websiteUrl: WebsiteIcon,
}

interface SocialLinksProps {
  links?: Partial<Record<SocialKey, string>>
  size?: 'sm' | 'md'
}

function SocialLinks({ links, size = 'md' }: SocialLinksProps) {
  const items = SOCIAL_FIELDS.map(field => {
    const href = withHttps(links?.[field.key])
    if (!href) return null
    const Icon = ICONS[field.key]
    return { ...field, href, Icon }
  }).filter(Boolean)

  if (!items.length) return null

  const box = size === 'sm' ? 'h-9 w-9' : 'h-10 w-10'
  const icon = size === 'sm' ? 'h-4 w-4' : 'h-4.5 w-4.5 h-[18px] w-[18px]'

  return (
    <div className="flex flex-wrap items-center gap-2">
      {items.map(item => item ? (
        <a
          key={item.key}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          title={item.label}
          className={`inline-flex ${box} items-center justify-center rounded-full border border-white/15 bg-white/5 text-white transition-colors hover:border-[#FFDE00] hover:bg-[#FFDE00] hover:text-black`}
        >
          <item.Icon className={icon} />
        </a>
      ) : null)}
    </div>
  )
}

export default SocialLinks
